import { POPUP_TYPE } from '../constants/popupType';

export const getModalSize = (type) => {
    switch (type) {
        case POPUP_TYPE.startBlemishReport:
        case POPUP_TYPE.bookDelivery:
            return 680;
        case POPUP_TYPE.valueBikeTrade:
        case POPUP_TYPE.valueBike:
        case POPUP_TYPE.updateValuationTrade:
        case POPUP_TYPE.updateValuation:
        case POPUP_TYPE.updatePrice:
            return 700;
        case POPUP_TYPE.HPICheck:
        case POPUP_TYPE.redoHPICheck:
            return 1100;
        default:
            return 540;
    }
};


// WEBPACK FOOTER //
// ./src/modules/Leads/utils/getModalSize.js